import {ApiRequestor} from "@/classes/requestors/api.requestor";

export class DtoApiEventPerson extends ApiRequestor {
  async $get(eventType, eventId, organizationId, sortBy, limit, offset) {
    const params = { eventType, eventId, organizationId }
    return this.$http('GET', '/eventPersonFields', {params})
  }
}
